module.exports = __webpack_public_path__ + "img/Réalisation rampe inox descente.dc6ff787.jpg";